<div class='ContentGroupListing'>
  <div class='ContentGroupListing-header d-flex flex-row'>
    <div
      class='ContentGroupListing-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='Breadcrumbs'>
        <div class='Breadcrumbs-items'>
          <a [routerLink]="['/contents']"
          >
            <mat-icon class='Breadcrumbs-icon back'
            >keyboard_backspace
            </mat-icon
            >
          </a
          >
          <a [routerLink]="['/contents']" class='Breadcrumbs-item'
          >Content Group</a
          >
        </div>
      </div>
      <app-svg-renderer
        (click)='onInfoImageClick()'
        [svg]="'Yellow Plane'"
        class='ms-3 mt-1 cursor-pointer'></app-svg-renderer>
    </div>
  </div>
  <div class='ContentGroupListing-table'>
    <app-table
      *ngIf='tableReady'
      [columns]='tableColumns'
      [dataSourceParams]='tableDataSourceParams'
      [dataSource]='dataSource'
      [filterGroups]='tableFilterGroups'
      [useRouteNavigation]='false'>
      <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
        <app-content-group-listing-mobile-row (request)='openRequestHelpDialog($event)'
                                              (update)='openUpdateContentDialog($event)'
                                              [item]='row'></app-content-group-listing-mobile-row>
      </ng-template>
    </app-table>
  </div>
</div>
